var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 14V9.067c0-.374 0-.56.073-.703a.667.667 0 0 1 .291-.291C5.507 8 5.694 8 6.067 8h1.866c.374 0 .56 0 .703.073a.667.667 0 0 1 .291.291c.073.143.073.33.073.703V14M6.345 1.843 1.824 5.359c-.303.236-.454.353-.563.5-.096.13-.168.278-.212.434C1 6.469 1 6.66 1 7.043v4.824c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V7.043c0-.383 0-.574-.05-.75a1.332 1.332 0 0 0-.211-.434c-.11-.147-.26-.264-.563-.5L7.655 1.843c-.234-.182-.351-.274-.48-.309a.667.667 0 0 0-.35 0c-.129.035-.246.127-.48.309Z"
  })));
};
export default SvgHome;